<template>
    <div class="grid grid-cols-2 gap-1" :title="company.campaign ? '' : 'Add this company to a campaign to record client feedback'">
        <button :disabled="!company.campaign" @click="markFeedback('approved')" class="text-xs p-1 border col-span-2 border-dark-primary rounded hover:bg-dark-primary hover:text-white hover:underline disabled:opacity-50 disabled:pointer-events-none">Approved</button>
        <button :disabled="!company.campaign" @click="markFeedback('excluded')" class="text-xs p-1 border border-dark-primary rounded hover:bg-dark-primary hover:text-white hover:underline disabled:opacity-50 disabled:pointer-events-none">Excl</button>
        <button :disabled="!company.campaign" @click="markFeedback('hold')" class="text-xs p-1 border border-dark-primary rounded hover:bg-dark-primary hover:text-white hover:underline disabled:opacity-50 disabled:pointer-events-none">Hold</button>
        <button :disabled="!company.campaign" @click="markFeedback('pass')" class="text-xs p-1 border border-dark-primary rounded hover:bg-dark-primary hover:text-white hover:underline disabled:opacity-50 disabled:pointer-events-none">Pass</button>
        <button :disabled="!company.campaign" @click="markFeedback('research_further')" class="text-xs p-1 border border-dark-primary rounded hover:bg-dark-primary hover:text-white hover:underline disabled:opacity-50 disabled:pointer-events-none">RF</button>
        <button :disabled="!company.campaign" @click="markFeedback('')" class="text-xs p-1 border col-span-2 border-dark-primary rounded bg-dark-primary text-white hover:underline disabled:opacity-50 disabled:pointer-events-none">None</button>
    </div>
</template>

<script>
    export default {
        name: "mark-client-feedback-buttons-cell"
    }
</script>

<script setup>
import { defineEmits, defineProps } from 'vue';
import { createCompanyClientFeedback, clientFeedbackErrorMessage } from '@/services/Company';
import { useStore } from 'vuex';
import { useToast } from 'vue-toast-notification';

    const store = useStore()
    const $toast = useToast()

    const props = defineProps({
        company:  Object
    })

    const emit = defineEmits(['refetch-companies'])

    async function markFeedback(feedback) {
        let token = store.state.auth.token
        const result = await createCompanyClientFeedback(props.company.id, feedback, token)
        if(result.status != 201) {
            $toast.open({ type: 'error', duration: 10000, message: clientFeedbackErrorMessage(result) })
            return
        }
        emit('refetch-companies')
    }


</script>
